/** "Se busca": the public board of cards people are looking for (merged into messages.ts). */
export const wantedEs = {
  "wanted.metaTitle": "Se busca: cartas que buscan los fans",
  "wanted.title": "Se busca",
  "wanted.intro": "Las cartas de Pokémon que buscan los fans. Si tenés alguna, publicala en el mercado y vendésela.",
  "wanted.post": "Publicar lo que buscás",
  "wanted.signInToPost": "Ingresá para publicar lo que buscás",
  "wanted.search": "Buscar carta",
  "wanted.searchHint": "Nombre, set o número",
  "wanted.trade": "Acepta canje",
  "wanted.priced": "Con precio",
  "wanted.province": "Provincia",
  "wanted.anyProvince": "Todas",
  "wanted.sort": "Ordenar",
  "wanted.sort.recent": "Más recientes",
  "wanted.sort.most": "Más buscadas",
  "wanted.apply": "Buscar",
  "wanted.clear": "Limpiar",
  "wanted.results": "{count} cartas buscadas",
  "wanted.results_one": "1 carta buscada",
  "wanted.empty": "Todavía nadie publicó lo que busca. ¡Sé el primero!",
  "wanted.emptyFiltered": "No hay cartas buscadas con esos filtros.",
  "wanted.wanting": "La buscan {count} personas",
  "wanted.wanting_one": "La busca 1 persona",
  "wanted.onSale": "Se vende desde {price} ({count})",
  "wanted.matches": "Tenés {count} cartas publicadas que alguien busca",
  "wanted.matches_one": "Tenés 1 carta publicada que alguien busca",
  "wanted.matchesHint": "Fijate qué pide cada uno: estado, idioma y precio.",
  "wanted.people": "{count} personas buscan",
  "wanted.people_one": "1 persona busca",
  "wanted.matchesLocked": "{people} {count} cartas que tenés publicadas",
  "wanted.matchesLocked_one": "{people} 1 carta que tenés publicada",
  "wanted.matchesLockedHint": "Con VMAX te decimos cuáles son y te avisamos en el momento en que alguien busca una carta que tenés.",
  "wanted.matchesSeeWhich": "Ver cuáles con VMAX",
  "wanted.haveOne": "¿Tenés alguna? Buscala por nombre y fijate quién la busca.",
  "wanted.moreProvinces": "+{count}",

  // A card's page
  "wanted.cardTitle": "Se busca {name}",
  "wanted.back": "← Se busca",
  "wanted.marketHas": "Ya la venden en el mercado desde {price}",
  "wanted.marketHas_one": "Ya la venden en el mercado a {price}",
  "wanted.seeOffers": "Ver ofertas",
  "wanted.marketNone": "Nadie la vende en el mercado ahora.",
  "wanted.iHaveIt": "La tengo",
  "wanted.meToo": "Yo también la busco",
  "wanted.noPosts": "Nadie la busca en público ahora.",
  "wanted.ago": "hace {count} días",
  "wanted.ago_one": "hace 1 día",
  "wanted.today": "hoy",
  "wanted.minCondition": "{condition} o mejor",
  "wanted.anyCondition": "Cualquier estado",
  "wanted.qty": "×{count}",
  "wanted.upTo": "Paga hasta {price}",
  "wanted.haveTitle": "¿Tenés esta carta?",
  "wanted.haveTitleSealed": "¿Tenés este producto?",
  "wanted.haveText": "Publicala en el mercado: a quien la busca le llega un aviso cuando se publica dentro del precio que puso, y la ve en las ofertas de la carta. Le cobrás directo, sin comisión.",
  "wanted.haveSeller": "Publicarla en mi tienda",
  "wanted.haveListed": "Si ya la tenés publicada, quien la busca la ve en las ofertas.",
  "wanted.haveNoShop": "Para vender necesitás una tienda: es gratis y podés publicar hasta 10 cartas.",
  "wanted.openShop": "Abrir mi tienda gratis",
  "wanted.signIn": "Ingresar",
  "wanted.tradeSoon": "¿Querés canjearla? Pronto vas a poder escribirle desde acá.",

  // The form
  "wanted.formTitle": "Publicar lo que buscás",
  "wanted.editTitle": "Editar lo que buscás",
  "wanted.formIntro": "Elegí la carta o el producto y contá cómo lo querés. La ven todos en Se busca, y te avisamos por email cuando alguien la publica.",
  "wanted.pick": "¿Qué carta o producto buscás?",
  "wanted.change": "Elegir otra",
  "wanted.condition": "Estado mínimo",
  "wanted.language": "Idioma",
  "wanted.anyLanguage": "Cualquiera",
  "wanted.quantity": "Cantidad",
  "wanted.maxPrice": "Precio máximo (opcional)",
  "wanted.maxPriceHint": "Te avisamos cuando alguien la publique a ese precio o menos.",
  "wanted.showPrice": "Mostrar mi precio en Se busca",
  "wanted.showPriceHint": "Si no lo mostrás, solo lo usamos para avisarte.",
  "wanted.acceptsTrade": "Acepto canje",
  "wanted.note": "Nota (opcional)",
  "wanted.noteHint": "Por ejemplo: «la quiero para completar el set». Sin teléfonos, links ni datos de pago.",
  "wanted.noteLink": "Sacá el link: en Se busca no se pueden poner links.",
  "wanted.noteContact": "Sacá los datos de contacto o de pago: en Se busca no se publican.",
  "wanted.yourProvince": "Tu provincia (opcional)",
  "wanted.noProvince": "No mostrar",
  "wanted.youAppear": "Te van a ver como",
  "wanted.youAppearShop": "Como tenés tienda, aparecés con tu @usuario.",
  "wanted.nickname": "Apodo",
  "wanted.nicknameHint": "Entre 2 y 24 letras o números. Vacío: tu nombre y la inicial del apellido.",
  "wanted.changeNickname": "Cambiar apodo",
  "wanted.saveNickname": "Guardar apodo",
  "wanted.nicknameTaken": "Ese nombre es de una tienda: elegí otro.",
  "wanted.nicknameInvalid": "Ese apodo no se puede usar.",
  "wanted.privacy": "Se muestran tu alias y tu provincia. Nunca tu email ni tu teléfono.",
  "wanted.preview": "Así lo van a ver",
  "wanted.publish": "Publicar en Se busca",
  "wanted.saveChanges": "Guardar cambios",
  "wanted.err.too_many_public": "Ya tenés 20 cartas en Se busca: sacá alguna desde «Lo que busco» para publicar otra.",
  "wanted.err.too_many": "Llegaste al máximo de 100 cartas en tu lista.",
  "wanted.err.blocked": "No podemos publicar esto. Si creés que es un error, escribinos.",
  "wanted.err.category_not_allowed": "Los accesorios no se buscan en el mercado.",

  // Mi mercado › Busco
  "wanted.visible": "Visible en Se busca",
  "wanted.onBoardUntil": "En Se busca hasta el {date}",
  "wanted.private": "Privado",
  "wanted.hidden": "pokefans lo sacó de Se busca",
  "wanted.fulfilled": "Conseguida ✓",
  "wanted.bump": "Subir",
  "wanted.bumpFrom": "Podés subirla de nuevo desde el {date}",
  "wanted.gotIt": "Ya la conseguí",
  "wanted.wantAgain": "La busco de nuevo",
  "wanted.edit": "Editar",
  "wanted.view": "Ver",
  "wanted.err.bump_too_soon": "Todavía no podés subirla: una vez por semana.",
  "wanted.err.fulfilled": "Ya la conseguiste: marcá «La busco de nuevo» para volver a publicarla.",

  // Elsewhere
  "wanted.productStrip": "{count} personas la buscan en Se busca",
  "wanted.productStrip_one": "1 persona la busca en Se busca",
  "wanted.productStripNone": "¿La buscás? Publicalo en Se busca",
  "wanted.onBoard": "{count} en Se busca",
  "nav.wantedBoard": "Ver lo que se busca",
  "nav.wantedBoardHint": "Las cartas que buscan los fans. Si tenés alguna, vendésela.",
  "nav.wantedPost": "Publicar lo que buscás",
  "nav.wantedPostHint": "Que la vean todos, y te avisamos cuando alguien la publica.",
};

export const wantedEn: Record<keyof typeof wantedEs, string> = {
  "wanted.metaTitle": "Wanted: cards fans are looking for",
  "wanted.title": "Wanted",
  "wanted.intro": "The Pokémon cards fans are looking for. If you have one, list it on the market and sell it to them.",
  "wanted.post": "Post what you're looking for",
  "wanted.signInToPost": "Sign in to post what you're looking for",
  "wanted.search": "Search card",
  "wanted.searchHint": "Name, set or number",
  "wanted.trade": "Takes trades",
  "wanted.priced": "With a price",
  "wanted.province": "Province",
  "wanted.anyProvince": "All",
  "wanted.sort": "Sort",
  "wanted.sort.recent": "Most recent",
  "wanted.sort.most": "Most wanted",
  "wanted.apply": "Search",
  "wanted.clear": "Clear",
  "wanted.results": "{count} wanted cards",
  "wanted.results_one": "1 wanted card",
  "wanted.empty": "Nobody has posted what they're looking for yet. Be the first!",
  "wanted.emptyFiltered": "No wanted cards with those filters.",
  "wanted.wanting": "{count} people want it",
  "wanted.wanting_one": "1 person wants it",
  "wanted.onSale": "On sale from {price} ({count})",
  "wanted.matches": "You have {count} listed cards someone wants",
  "wanted.matches_one": "You have 1 listed card someone wants",
  "wanted.matchesHint": "Check what each one asks for: condition, language and price.",
  "wanted.people": "{count} people want",
  "wanted.people_one": "1 person wants",
  "wanted.matchesLocked": "{people} {count} cards you have listed",
  "wanted.matchesLocked_one": "{people} 1 card you have listed",
  "wanted.matchesLockedHint": "With VMAX we tell you which ones and let you know the moment someone looks for a card you have.",
  "wanted.matchesSeeWhich": "See which with VMAX",
  "wanted.haveOne": "Have one? Search it by name and see who wants it.",
  "wanted.moreProvinces": "+{count}",

  "wanted.cardTitle": "Wanted: {name}",
  "wanted.back": "← Wanted",
  "wanted.marketHas": "On sale on the market from {price}",
  "wanted.marketHas_one": "On sale on the market at {price}",
  "wanted.seeOffers": "See offers",
  "wanted.marketNone": "Nobody sells it on the market right now.",
  "wanted.iHaveIt": "I have it",
  "wanted.meToo": "I want it too",
  "wanted.noPosts": "Nobody is publicly looking for it right now.",
  "wanted.ago": "{count} days ago",
  "wanted.ago_one": "1 day ago",
  "wanted.today": "today",
  "wanted.minCondition": "{condition} or better",
  "wanted.anyCondition": "Any condition",
  "wanted.qty": "×{count}",
  "wanted.upTo": "Pays up to {price}",
  "wanted.haveTitle": "Have this card?",
  "wanted.haveTitleSealed": "Have this product?",
  "wanted.haveText": "List it on the market: whoever wants it gets an alert when it's listed within the price they set, and sees it among the card's offers. They pay you directly, no fees.",
  "wanted.haveSeller": "List it in my shop",
  "wanted.haveListed": "If you already listed it, they see it among the offers.",
  "wanted.haveNoShop": "To sell you need a shop: it's free and you can list up to 10 cards.",
  "wanted.openShop": "Open my free shop",
  "wanted.signIn": "Sign in",
  "wanted.tradeSoon": "Want to trade it? Soon you'll be able to message them from here.",

  "wanted.formTitle": "Post what you're looking for",
  "wanted.editTitle": "Edit what you're looking for",
  "wanted.formIntro": "Pick the card or product and say how you want it. Everyone sees it on Wanted, and we email you when someone lists it.",
  "wanted.pick": "Which card or product are you looking for?",
  "wanted.change": "Pick another",
  "wanted.condition": "Minimum condition",
  "wanted.language": "Language",
  "wanted.anyLanguage": "Any",
  "wanted.quantity": "Quantity",
  "wanted.maxPrice": "Max price (optional)",
  "wanted.maxPriceHint": "We tell you when someone lists it at that price or less.",
  "wanted.showPrice": "Show my price on Wanted",
  "wanted.showPriceHint": "If you don't, we only use it to alert you.",
  "wanted.acceptsTrade": "I take trades",
  "wanted.note": "Note (optional)",
  "wanted.noteHint": "For example: \"to complete the set\". No phones, links or payment details.",
  "wanted.noteLink": "Remove the link: links aren't allowed on Wanted.",
  "wanted.noteContact": "Remove the contact or payment details: they're not published on Wanted.",
  "wanted.yourProvince": "Your province (optional)",
  "wanted.noProvince": "Don't show",
  "wanted.youAppear": "You'll show as",
  "wanted.youAppearShop": "Since you have a shop, you show with your @username.",
  "wanted.nickname": "Nickname",
  "wanted.nicknameHint": "2 to 24 letters or numbers. Empty: your first name and last initial.",
  "wanted.changeNickname": "Change nickname",
  "wanted.saveNickname": "Save nickname",
  "wanted.nicknameTaken": "That's a shop's name: pick another one.",
  "wanted.nicknameInvalid": "That nickname can't be used.",
  "wanted.privacy": "Your alias and province are shown. Never your email or phone.",
  "wanted.preview": "This is how they'll see it",
  "wanted.publish": "Post on Wanted",
  "wanted.saveChanges": "Save changes",
  "wanted.err.too_many_public": "You already have 20 cards on Wanted: take one off from \"Cards I'm looking for\" to post another.",
  "wanted.err.too_many": "You reached the limit of 100 cards on your list.",
  "wanted.err.blocked": "We can't post this. If you think it's a mistake, write to us.",
  "wanted.err.category_not_allowed": "Accessories aren't wanted on the market.",

  "wanted.visible": "Visible on Wanted",
  "wanted.onBoardUntil": "On Wanted until {date}",
  "wanted.private": "Private",
  "wanted.hidden": "pokefans took it off Wanted",
  "wanted.fulfilled": "Got it ✓",
  "wanted.bump": "Move up",
  "wanted.bumpFrom": "You can move it up again from {date}",
  "wanted.gotIt": "I got it",
  "wanted.wantAgain": "I want it again",
  "wanted.edit": "Edit",
  "wanted.view": "View",
  "wanted.err.bump_too_soon": "You can't move it up yet: once a week.",
  "wanted.err.fulfilled": "You already got it: tap \"I want it again\" to post it again.",

  "wanted.productStrip": "{count} people want it on Wanted",
  "wanted.productStrip_one": "1 person wants it on Wanted",
  "wanted.productStripNone": "Looking for it? Post it on Wanted",
  "wanted.onBoard": "{count} on Wanted",
  "nav.wantedBoard": "See what's wanted",
  "nav.wantedBoardHint": "The cards fans are looking for. Have one? Sell it to them.",
  "nav.wantedPost": "Post what you're looking for",
  "nav.wantedPostHint": "Everyone sees it, and we tell you when someone lists it.",
};
